// Centralized UI strings for ID format builder

export const UI_TEXT = {
    NO_PATTERN_DEFINED: 'No pattern defined yet',
    INPUT_COUNT_PLACEHOLDER: 'Count',
    INPUT_CONSTANT_PLACEHOLDER: 'Enter value',
    INPUT_INCREMENTAL_PLACEHOLDER: 'e.g., 0001',

    ENFORCE_INPUT_HEADING: 'Do you want to enforce input for the <X> ID field?',
    REQUIRED_LABEL: 'Required',
    OPTIONAL_LABEL: 'Optional',

    MODE_SELECT_HEADING:
        'Should the system auto-generate the <X> ID, or will it be provided by the user?',
    MODE_AUTOGENERATE: 'Auto-Generate',
    MODE_MANUAL: 'Manual',

    PATTERN_CONFIG_HEADING:
        'What is the required pattern or format for the <X> ID?',
    INSTRUCTION_TEXT:
        'Build a string by dragging tags from below and dropping them into the textbox.',
    DRAG_PLACEHOLDER: 'Drag tags here to build pattern',
    PATTERN_PREVIEW_LABEL: 'Pattern Preview:',
    AVAILABLE_TAGS_LABEL: 'Available Tags:',
    AUTOGEN_WARNING:
        '⚠ Auto-Generate mode requires at least one "Incremental digits starting from" tag',

    PREVIEW_FALLBACK_VALUE: 'VALUE',
    PREVIEW_FALLBACK_INCREMENTAL: '0001',
    PREVIEW_SITE_ID: '{SITE_ID}',
    PREVIEW_STUDY_ID: '{STUDY_ID}'
}

// Tag display labels for available tags (descriptive)
export const TAG_LABELS = {
    letters_uppercase: 'Letters (Uppercase) → only A–Z',
    letters_lowercase: 'Letters (Lowercase) → only a–z',
    letters_mixed: 'Letters (Mixed Case) → random mix',
    digits: 'Digits (0–9)',
    alphanumeric_uppercase: 'Alphanumerics (Uppercase) → [A–Z0–9]',
    alphanumeric_lowercase: 'Alphanumerics (Lowercase) → [a–z0–9]',
    alphanumeric_mixed: 'Alphanumerics (Mixed Case) → [A–Za–z0–9]',
    hyphen: 'Hyphen',
    constant_value: 'Constant Value',
    incremental_digits: 'Incremental digits starting from',
    site_id: 'Site ID',
    study_id: 'Study ID'
}

// Short labels for tags in the pattern builder (concise)
export const TAG_SHORT_LABELS = {
    letters_uppercase: 'Letters (A-Z)',
    letters_lowercase: 'Letters (a-z)',
    letters_mixed: 'Letters (Mixed)',
    digits: 'Digits',
    alphanumeric_uppercase: 'Alphanumeric (A-Z0-9)',
    alphanumeric_lowercase: 'Alphanumeric (a-z0-9)',
    alphanumeric_mixed: 'Alphanumeric (Mixed)',
    hyphen: 'Hyphen',
    constant_value: 'Constant',
    incremental_digits: 'Incremental',
    site_id: 'Site ID',
    study_id: 'Study ID'
}

// ID keys and labels
export const PRESCREEN_ID_KEY = 'pre_screen_id'
export const PRESCREEN_ID_LABEL = 'Pre-Screen ID'
export const SUBJECT_ID_KEY = 'subject_id'
export const SUBJECT_ID_LABEL = 'Subject ID'

// Error messages
export const CREATE_STUDY_ERROR_PREFIX = 'The Study cannot be created: '

// Review screen display strings
export const REVIEW_SCREEN_TEXT = {
    MODE_LABEL: 'Mode:',
    REQUIRED_LABEL: 'Required:',
    FORMAT_LABEL: 'Format:',
    YES: 'Yes',
    NO: 'No',
    NO_FORMAT_DEFINED: 'No format defined'
}


